import React, { FC, useState, useRef, useEffect } from 'react'
import { Button, SearchInput, Select } from '..'
import {
  Container,
  RightSideContainer,
  ProfileContainer,
  ProfileName,
  ChevronIc,
  DropDownProfile,
  NotificationsContainer,
  BalanceContainer,
  HeaderControlsCluster,
  IconActionsContainer,
  HamburgerButton,
  HeaderLeft,
  SearchContainer,
} from './styles'
import StyledIcon from '../styled-icon'
import PaperIcon from './paper.svg'
import PaperDarkIcon from './paper-dark.svg'
import NotificationIcon from './notifications.svg'
import NotificationDarkIcon from './notifications-dark.svg'
import NoNotificationsIcon from './no-notification.svg'
import NoNotificationsDarkIcon from './no-notification-dark.svg'
import ChevronIcon from './chevron.svg'
import ChevronDarkIcon from './chevron-dark.svg'
import NotificationsModal from './components/notifications'
import { useUi } from "../../context/ui.context";
import DropOptions from "./components/drop-options";
import { useAuth } from '../../context/user.context'
import { billingService } from '../../api'
import { useLocation, useNavigate } from 'react-router-dom'
import { icons } from '../../icons'
import Gravatar from 'react-gravatar'
import UaFlag from './ua-flag.svg'
import { useTranslation } from 'react-i18next'
import { ErrorContainer, ErrorText } from '../../pages/HomePage/styles'
import AlertIcon from './error.svg'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { BodySmall, VerySmall } from '../typography/styled'
import { useTheme } from 'styled-components'
import { formatCurrency } from '../../utils/display-price'
import rootConfig from '../../config'
import NlFlag from './nl-flag.svg'
import { routePermissionSurfaces, usePermissionDecision } from '../../permissions'
import { confirmRegistrationRegion, setStoredRegion } from '../../utils/region'


const Header:FC = () => {
  const [t] = useTranslation()
  const profileRef:any = useRef()
  const notificationsRef:any = useRef()
  const notificationIconRef:any = useRef()
  const {removeItemFromLs} = useLocalStorage()
  const [billingData, setBillingData] = useState<any>()
  const theme:any = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const [activeDrop, setActiveDrop] = useState<boolean>(false)
  const [activeNotifications, setActiveNotifications] = useState<boolean>(false)
  const {smallBar,
    setSmallBar,
    setViewModalComplete,
    setActiveAnimationComplete,
  } = useUi()
  const {user, notifications} = useAuth()
  const billingDecision = usePermissionDecision(routePermissionSurfaces.billing)
  const dropOptionsRef:any = useRef()
  const [region, setRegion] = useState<any>('')
  useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
      document.removeEventListener('click', handleClickOutside, true);
		};
  },[]);
  const updateBillingData = () => {
    billingService.getSummary()
    .then(async(res) => {
      setBillingData(res.data)
    })
    .catch(() => {
      setBillingData(undefined)
    })
  }
  const handleClickOutside = (event:any) => {
    if (dropOptionsRef?.current && profileRef?.current && !dropOptionsRef.current.contains(event.target) && !profileRef.current.contains(event.target)){
      setActiveDrop(false)
    }
    if (notificationsRef?.current && notificationIconRef?.current && !notificationsRef.current.contains(event.target) && !notificationIconRef.current.contains(event.target)){
      setActiveNotifications(false)
    }
  }
  const userData = user?.user
  useEffect(() => {
    setRegion(setStoredRegion(localStorage.getItem('region_ocp_zone')))
  },[])
  useEffect(() => {
    if (!billingDecision.allowed) {
      setBillingData(undefined)
      return
    }

    updateBillingData()
  }, [billingDecision.allowed, user?.user?.active_client])
  const regions = [
    {
      icon:UaFlag,
      label:'ua-1',
      value:'ua-1',
    },
    {
      icon:NlFlag,
      label:'nl-1',
      value:'nl-1',
    }
  ]
  const changeRegion = (region:any) => {
      const selectedRegion = setStoredRegion(region)
      if (!user.user.active_client) {
        confirmRegistrationRegion(selectedRegion, user.user.id ?? user.user.email)
      }
      removeItemFromLs('instance.configure')
      removeItemFromLs('instance.network')
      removeItemFromLs('cluster.type')
      removeItemFromLs('cluster.configure_master')
      removeItemFromLs('cluster.configure_pools')
      removeItemFromLs('cluster.poools')
      removeItemFromLs('cluster.add-ons')
      removeItemFromLs('cluster.networking')
      window.location.reload()
  }

  const verEmail = () => {
    setViewModalComplete(true)
    setActiveAnimationComplete(true)
  }
  return(
    <>
      <Container data-test-id='header-container' isSmall={smallBar}>
        <HeaderLeft>
          <HamburgerButton aria-label={t("MENU")} onClick={() => setSmallBar(false)}>
            <span />
            <span />
            <span />
          </HamburgerButton>
          <SearchContainer isSmall={smallBar}>
            <SearchInput/>
          </SearchContainer>
        </HeaderLeft>
        {/* <div/> */}
        <RightSideContainer>
          <HeaderControlsCluster>
            <Select
              data={regions}
              isRegion
              selectedValue={region || regions[0]?.value}
              onChange={(e) => changeRegion(e)}
              customStyles={{width:'87px', minWidth:'87px'}}
              customDropStyles={{padding:'5px 7px 3px 9px'}}
              title={''}
              toolTip={false}
            />
            {billingData && billingDecision.allowed &&
              <BalanceContainer>
                <VerySmall style={{color:theme.grey[600], textTransform:"uppercase", fontSize:"8px", lineHeight:'9.68px'}}>
                  {t("BALANCE")}
                </VerySmall>
                <div style={{display:'flex', alignItems:'center', width:'100%', gap:'4px'}}>
                  <BodySmall onClick={() => {
                    navigate('/billing/overview')
                  }} style={{whiteSpace:'nowrap', color:theme.neutral[100]}}>
                    {formatCurrency(billingData?.uptodate_credit.toFixed(2), billingData?.billing_currency)}
                  </BodySmall>
                  <StyledIcon onClick={() => {
                    navigate('/billing/overview?modal=add_payment')
                  }} src={icons.PlusDefault}/>
                </div>
              </BalanceContainer>
            }
            <IconActionsContainer data-test-id='header-icon-actions' ref={notificationIconRef}>
              <img
                onClick={() => setActiveNotifications(!activeNotifications)}
                src={notifications?.extra?.unseen_count > 0 && notifications.count > 0
                  ? theme.isDark ? NotificationDarkIcon : NotificationIcon
                  : theme.isDark ? NoNotificationsDarkIcon : NoNotificationsIcon}
                alt={t("NOTIFICATIONS")}
              />
              <img
                onClick={() => window.open(rootConfig.docs_url)}
                src={theme.isDark ? PaperDarkIcon : PaperIcon}
                alt={t("DOCUMENTATION")}
              />
            </IconActionsContainer>
          </HeaderControlsCluster>
          <ProfileContainer
            data-test-id='profile-settings-dropdown'
            ref={profileRef}
            onClick={() => setActiveDrop(!activeDrop)}
          >
            <Gravatar
              email={userData?.email}
              size={24}
              style={{borderRadius: '100%'}}
            />
            <ProfileName>
              {userData?.email}
            </ProfileName>
            <ChevronIc active={activeDrop} src={theme.isDark ? ChevronDarkIcon : ChevronIcon}/>
          </ProfileContainer>
          <DropDownProfile ref={dropOptionsRef} active={activeDrop}>
            <DropOptions
              handleClose={() => setActiveDrop(false)}
            />
          </DropDownProfile>
        </RightSideContainer>
        <NotificationsContainer
          active={activeNotifications}
          ref={notificationsRef}
        >
          <NotificationsModal />
        </NotificationsContainer>

      </Container>
      {(!user.user.active_client || user.requires_email_verification)
        && !location.pathname.includes('/home')
        && window.location.href.indexOf('/complete-registration') === -1 ?
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          boxSizing:'border-box',
          paddingRight:"20px",
          paddingLeft:"20px", 
          marginBottom:'10px'
        }}>
            <ErrorContainer style={{marginTop:'0px'}} isError={true}>
            <div style={{display:'flex', alignItems:"center", gap:'6px'}}>
              <img src={AlertIcon}/>
              <ErrorText>{t("ERROR_VERIFICATION_MESSAGE")}</ErrorText>
            </div>
            <Button
              title={!user.user.active_client ? t("GO_TO_CREATE_CLIENT") : t("VERIFY_EMAIL")}
              onClick={!user.user.active_client ? () => navigate("/complete-registration") : () => verEmail()}
              size='small'
              variant='primary'
            />
          </ErrorContainer>
        </div>
      : null}
    </>
  )
}

export default Header
